import AboutAuthor from "@/components/site/AboutAuthor";
import { Seo } from "@/components/Seo";

export default function AuthorPage() {
  return (
    <main data-testid="page-author" className="pt-20">
      <Seo
        title="About Dr. Dennis Louden — Delta DL Enterprise, LLC"
        description="Meet Dr. Dennis Louden — nurse, author, artist, and educator behind Delta DL Enterprise, LLC."
        path="/author"
      />
      <AboutAuthor />
    </main>
  );
}
